import axios from 'axios'

import { XLSX_API_BASE_URL } from '../../config/env'
import { toCamelCase } from '../../utils'

export const startGenerateXlsx = async ({
  queueUrl,
  document,
  hash,
  s3InputPath,
  userId,
  scope,
  bucketOutput,
  discoveryStartedAt
}) => {
  const { data } = await axios.post(`${XLSX_API_BASE_URL}/v1/start`, {
    queueUrl,
    document,
    hash,
    s3InputPath,
    userId,
    scope,
    bucketOutput,
    discoveryStartedAt
  })

  return toCamelCase(data)
}
